import { render } from "./claimtypes.vue?vue&type=template&id=6521ef94&lang=html"
import script from "./claimtypes.vue?vue&type=script&lang=js"
export * from "./claimtypes.vue?vue&type=script&lang=js"

import "./claimtypes.vue?vue&type=style&index=0&id=6521ef94&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__